import { SweepFieldTypes } from '../../../../../../../types/enums/SweepFieldTypes';
import { CriteriaPluginSection } from '../../base-criteria-plugin-panel/types';
import { CSvg, DSvg, ESvg, ISvg, MSvg } from '../../med-icons';

export const meddicPluginStepMapping: CriteriaPluginSection[] = [
  {
    title: 'Metrics',
    icon: <MSvg />,
    pluginFields: [
      {
        pluginFieldId: 'metrics',
        fieldName: 'Metrics',
        apiName: 'Metrics__c',
        type: SweepFieldTypes.Text,
        description: '',
      },
      {
        pluginFieldId: 'metricStatus',
        fieldName: 'Metric Status',
        apiName: 'Metrics_Status__c',
        type: SweepFieldTypes.Picklist,
        picklistValueSet: [
          { default: false, fullName: 'a', label: 'a' },
          { default: false, fullName: 'b', label: 'b' },
        ],
        description: '',
      },
    ],
  },
  {
    title: 'Economic Buyer',
    icon: <ESvg />,
    pluginFields: [
      {
        pluginFieldId: 'economicBuyer',
        fieldName: 'Economic Buyer',
        apiName: 'Economic_Buyer__c',
        type: SweepFieldTypes.Lookup,
        lookupFieldProps: {
          lookupRelationshipName: 'EconomicBuyerContacts',
          lookupObjectName: 'Contact',
        },
        description: '',
      },
      {
        pluginFieldId: 'economicBuyerStatus',
        fieldName: 'Economic Buyer Status',
        apiName: 'Economic_Buyer_Status__c',
        type: SweepFieldTypes.Picklist,
        picklistValueSet: [
          { default: false, fullName: 'a', label: 'a' },
          { default: false, fullName: 'b', label: 'b' },
        ],
        description: '',
      },
    ],
  },
  {
    title: 'Decision Criteria',
    icon: <DSvg />,
    pluginFields: [
      {
        pluginFieldId: 'decisionCriteria',
        fieldName: 'Decision Criteria',
        apiName: 'Decision_Criteria__c',
        type: SweepFieldTypes.Text, // FreeText ?
        description: '',
      },
      {
        pluginFieldId: 'decisionCriteriaStatus',
        fieldName: 'Decision Criteria Status',
        apiName: 'Decision_Criteria_Status__c',
        type: SweepFieldTypes.Picklist,
        picklistValueSet: [
          { default: false, fullName: 'a', label: 'a' },
          { default: false, fullName: 'b', label: 'b' },
        ],
        description: '',
      },
    ],
  },
  {
    title: 'Decision Process',
    icon: <DSvg />,
    pluginFields: [
      {
        pluginFieldId: 'decisionProcess',
        fieldName: 'Decision Process',
        apiName: 'Decision_Process__c',
        type: SweepFieldTypes.Text, // FreeText ?
        description: '',
      },
      {
        pluginFieldId: 'decisionProcessStatus',
        fieldName: 'Decision Process Status',
        apiName: 'Decision_Process_Status__c',
        type: SweepFieldTypes.Picklist,
        picklistValueSet: [
          { default: false, fullName: 'a', label: 'a' },
          { default: false, fullName: 'b', label: 'b' },
        ],
        description: '',
      },
    ],
  },
  {
    title: 'Identify Pain',
    icon: <ISvg />,
    pluginFields: [
      {
        pluginFieldId: 'identifyPain',
        fieldName: 'Identify Pain',
        apiName: 'Identify_Pain__c',
        type: SweepFieldTypes.Text, // FreeText ?
        description: '',
      },
      {
        pluginFieldId: 'identifyPainStatus',
        fieldName: 'Identify Pain Status',
        apiName: 'Identify_Pain_Status__c',
        type: SweepFieldTypes.Picklist,
        picklistValueSet: [
          { default: false, fullName: 'a', label: 'a' },
          { default: false, fullName: 'b', label: 'b' },
        ],
        description: '',
      },
    ],
  },
  {
    title: 'Champion',
    icon: <CSvg />,
    pluginFields: [
      {
        pluginFieldId: 'champion',
        fieldName: 'Champion',
        apiName: 'Champion__c',
        type: SweepFieldTypes.Lookup,
        lookupFieldProps: {
          lookupRelationshipName: 'ChampionContacts',
          lookupObjectName: 'Contact',
        },
        description: '',
      },
      {
        pluginFieldId: 'championStatus',
        fieldName: 'Champion Status',
        apiName: 'Champion_Status__c',
        type: SweepFieldTypes.Picklist,
        picklistValueSet: [
          { default: false, fullName: 'a', label: 'a' },
          { default: false, fullName: 'b', label: 'b' },
        ],
        description: '',
      },
    ],
  },
];
